import { render, staticRenderFns } from "./PaymentFrequency.vue?vue&type=template&id=23da5af9&scoped=true&"
import script from "./PaymentFrequency.vue?vue&type=script&lang=js&"
export * from "./PaymentFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da5af9",
  null
  
)

export default component.exports